/**
 * Extracts a user-friendly error message from API error responses
 * Handles Pydantic validation errors (arrays), string errors, and object errors
 * @param {Error} error - The error object from axios/fetch
 * @param {string} defaultMessage - Fallback message if error cannot be parsed
 * @returns {string} - User-friendly error message
 */
export const getErrorMessage = (error, defaultMessage = 'An error occurred') => {
  // Check if there's a response with detail
  if (error.response?.data?.detail) {
    const detail = error.response.data.detail;
    
    // Handle array of validation errors (Pydantic)
    if (Array.isArray(detail)) {
      return detail.map(err => {
        if (typeof err === 'string') return err;
        if (err.msg) return err.msg;
        if (err.message) return err.message;
        return JSON.stringify(err);
      }).join(', ');
    }
    
    // Handle string errors
    if (typeof detail === 'string') {
      return detail;
    }
    
    // Handle object errors
    if (typeof detail === 'object') {
      if (detail.msg) return detail.msg;
      if (detail.message) return detail.message;
      return JSON.stringify(detail);
    }
  }
  
  // Check for error message in other formats
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  
  if (error.message) {
    return error.message;
  }
  
  return defaultMessage;
};
